import { ref, onMounted, onBeforeUnmount } from 'vue'

const isUsingKeyboard = ref(false)

export function useKeyboardNavigationDetection () {
  const handleFirstTab = (e: KeyboardEvent) => {
    if (e.key === 'Tab') {
      isUsingKeyboard.value = true
      document.body.classList.add('using-keyboard')
      window.removeEventListener('keydown', handleFirstTab)
      window.addEventListener('mousedown', handleMouseDownOnce)
    }
  }

  const handleMouseDownOnce = () => {
    isUsingKeyboard.value = false
    document.body.classList.remove('using-keyboard')
    window.removeEventListener('mousedown', handleMouseDownOnce)
    window.addEventListener('keydown', handleFirstTab)
  }

  onMounted(() => {
    window.addEventListener('keydown', handleFirstTab)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleFirstTab)
    window.removeEventListener('mousedown', handleMouseDownOnce)
  })

  return {
    isUsingKeyboard
  }
}
